export var AcPowerSystemId;
(function (AcPowerSystemId) {
    AcPowerSystemId["METERED_SINGLE_PHASE"] = "METERED_SINGLE_PHSAE";
    AcPowerSystemId["METERED_SPLIT_PHASE"] = "METERED_SPLIT_PHASE";
    AcPowerSystemId["METERED_THREE_PHASE"] = "METERED_THREE_PHASE";
    AcPowerSystemId["FIXED_120V_SPLIT_PHASE"] = "FIXED_120V_SPLIT_PHASE";
    AcPowerSystemId["FIXED_230V_SINGLE_PHASE"] = "FIXED_230V_SINGLE_PHASE";
    AcPowerSystemId["FIXED_230V_THREE_PHASE"] = "FIXED_230V_THREE_PHASE";
    AcPowerSystemId["FIXED_480V_THREE_PHASE"] = "FIXED_480V_THREE_PHASE";
    AcPowerSystemId["FIXED_600V_THREE_PHASE"] = "FIXED_600V_THREE_PHASE";
})(AcPowerSystemId || (AcPowerSystemId = {}));
export var PowerMeteringType;
(function (PowerMeteringType) {
    PowerMeteringType["VIRTUAL"] = "Virtual";
    PowerMeteringType["REAL"] = "Real";
})(PowerMeteringType || (PowerMeteringType = {}));
export const PanelEnergySourceToAcPowerSystemId = {
    SINGLE_PHASE: 'METERED_SINGLE_PHASE',
    SPLIT_PHASE: 'METERED_SPLIT_PHASE',
    THREE_PHASE: 'METERED_THREE_PHASE',
    THREE_PHASE_DELTA_PANEL: 'METERED_THREE_PHASE_DELTA_PANEL_HIGH_LEG',
};
